import AssignmentsIndex from '@/views/assignments/AssignmentsIndex.vue';
import AddAssignment from '@/views/assignments/AddAssignment.vue';
import EditAssignment from '@/views/assignments/EditAssignment.vue';

export default [
  {
    path: '/assignments',
    name: 'assignments.index',
    component: AssignmentsIndex,
    meta: { 
      title: 'assignments.indexTitle', 
      requiresAuth: true
    },
    children: [
      {
        path: 'add',
        name: 'assignments.create',
        component: AddAssignment,
        meta: { 
          title: 'assignments.addTitle', 
          requiresAuth: true
        }
      },
      {
        path: ':id/edit',
        name: 'assignments.edit',
        component: EditAssignment,
        meta: { 
          title: 'assignments.editTitle', 
          requiresAuth: true
        },
        props: true
      },
      {
        path: ':assignmentId/submissions',
        name: 'assignments.submissions',
        component: () => import('@/views/assignments/SubmissionsIndex.vue'),
        meta: { 
          title: 'assignments.submissionsTitle', 
          requiresAuth: true
        },
        props: true
      },
      {
        path: ':assignmentId/submissions/create',
        name: 'assignments.submit',
        component: () => import('@/views/assignments/SubmissionForm.vue'),
        meta: { 
          title: 'assignments.submitTitle', 
          requiresAuth: true
        }
      },
      {
        path: 'student/assignments/:assignmentId/submit',
        name: 'student.assignments.submit',
        component: () => import('@/views/students/isStudent/StudentAssignmentSubmit.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: ':assignmentId/submissions/:id/edit',
        name: 'assignments.submissions.edit',
        component: () => import('@/views/assignments/SubmissionForm.vue'),
        meta: { 
          title: 'assignments.submissions.editTitle', 
          requiresAuth: true,
          role: 'teacher'
        },
        props: true
      }
    ]
  }
];
